import { useState } from "react";
import { FileText } from "lucide-react";
import { FUNDING_ROUNDS, GROWTH_METRICS } from "../data/investorRelations";
import InvestorDeckRequestModal from "./InvestorDeckRequestModal";
import { trackEvent } from "../utils/analytics";

export default function FundingHistorySection() {
  const [deckModalOpen, setDeckModalOpen] = useState(false);
  const growthStats = [
    { label: "Coastal Cities", value: GROWTH_METRICS.cities },
    ...(GROWTH_METRICS.gmvGrowth ? [{ label: "GMV Growth", value: GROWTH_METRICS.gmvGrowth }] : []),
    ...(GROWTH_METRICS.customerGrowth ? [{ label: "Customer Growth", value: GROWTH_METRICS.customerGrowth }] : []),
  ];

  return (
    <div>
      <div
        className={`grid gap-6 ${
          growthStats.length >= 3 ? "sm:grid-cols-3" : growthStats.length === 2 ? "sm:grid-cols-2" : "mx-auto max-w-xs"
        }`}
      >
        {growthStats.map((stat) => (
          <div key={stat.label} className="rounded-2xl bg-foam-50 p-5 text-center dark:bg-white/5">
            <p className="font-display text-2xl font-bold text-ocean-900 dark:text-foam-50">{stat.value}</p>
            <p className="mt-1 text-xs font-medium uppercase tracking-wide text-ocean-700/70 dark:text-foam-100/70">
              {stat.label}
            </p>
          </div>
        ))}
      </div>

      {FUNDING_ROUNDS.length > 0 && (
        <ul className="mt-6 space-y-2">
          {FUNDING_ROUNDS.map((round) => (
            <li
              key={round.id}
              className="rounded-xl bg-foam-50 p-4 text-sm dark:bg-white/5"
            >
              <span className="font-semibold text-ocean-950 dark:text-foam-50">{round.roundName}</span>
              <span className="text-ocean-800/60 dark:text-foam-100/60"> · {round.year}</span>
              {round.headlineInvestors && round.headlineInvestors.length > 0 && (
                <p className="mt-1 text-xs text-ocean-800/60 dark:text-foam-100/60">
                  {round.headlineInvestors.join(", ")}
                </p>
              )}
            </li>
          ))}
        </ul>
      )}

      <button
        type="button"
        onClick={() => {
          trackEvent("investor_deck_request_open");
          setDeckModalOpen(true);
        }}
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-teal-400 px-6 py-3 text-sm font-semibold text-ocean-950 transition-transform hover:scale-105"
      >
        <FileText className="h-4 w-4" />
        Request Investor Deck
      </button>

      <InvestorDeckRequestModal open={deckModalOpen} onClose={() => setDeckModalOpen(false)} />
    </div>
  );
}
